import axios, { getData } from 'lib/axios'

export const getCourseDashboard = async () => {
  // query params is temporary until we integrate with bootcamp as well
  const { data } = await axios.get('/adx_edu/course?type=course').then(getData)
  return data
}
